<span class="brand-logo d-inline-flex align-items-center" [class.brand-logo--light]="light" [class.brand-logo--rewards]="product.trim().toLowerCase() === 'rewards'" [class.brand-logo--shop]="product.trim().toLowerCase() === 'shop'" [style.font-size.px]="size">
  <ng-container *ngIf="productLogoUrl; else htmlLockup">
    <img class="brand-logo__full" [src]="productLogoUrl" [alt]="altText" [style.height.px]="size" />
  </ng-container>
  <ng-template #htmlLockup>
    <img
      class="brand-logo__icon"
      src="https://company.rubbl.com/pubweb/marketplace/images/logos/rubbl-logo-no-text.svg"
      [alt]="altText"
    />
    <span class="brand-logo__text teko text-uppercase font-weight-500">Rubbl&nbsp;<span class="text-red">{{ product }}</span></span>
  </ng-template>
</span>
